const mainContent = document.getElementById('MainContent');
const a = Array.from(document.getElementsByTagName('a'));

a.forEach((link) => {
  link.addEventListener('click', (e) => {
    const href = link.getAttribute('href');
    const target = link.getAttribute('target');

    if (target === '_blank') {

    } else if (href.startsWith('#')) {

    } else {
      e.preventDefault();
      mainContent.classList.add('hide');
      mainContent.classList.add('leave');
      setTimeout(() => {
        window.location.href = href;
      }, 300);
    }
  });
});

setTimeout(() => {
  mainContent.classList.remove('hide');
  mainContent.classList.remove('prepare');
}, 300);

window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    mainContent.classList.remove('leave');
    mainContent.classList.add('prepare');
    mainContent.classList.add('hide');
    requestAnimationFrame(() => {
      setTimeout(() => {
        mainContent.classList.remove('hide');
        mainContent.classList.remove('prepare');
      }, 300);
    });
  }
});